// extracted by mini-css-extract-plugin
export default {"header":"header__header-UOjHH","label":"header__label-A8hOG"};